import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import moment from 'moment';
// import 'moment/locale/uk';
import { Button } from 'react-bootstrap';

import ModalConfirmation from './modalConfirmation';
import defaultMedicSvg from '../../../../assets/img/next/svg/medic.svg';
import videoSvg from '../../../../assets/img/video-svgrepo-com.svg';

export default function Doctor(props) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  const {
    cabinet_num,
    cancelable,
    cancelable_comment,
    cancelAppointment,
    division,
    doctor,
    id,
    institution,
    time_from,
    work_date,
    isPast,
    city,
    is_video_conference,
    uid_video_conference,
    patient,
    start_at,
    speciality,
    deleted,
  } = props;
  
  const onConfirmDelete = (id) => {
    handleClose();
    cancelAppointment(id);
  }; 

  var duration = moment.duration(moment(start_at).diff(moment(new Date()))).asMinutes();

  return (
    <div className={`streaming-records-item ${deleted === true ? 'canceled-appointment' : ''}`}>
      {deleted === true && (
        <div className="canceled-appointment-overlay">
          <div className="canceled-appointment-message">Прийом скасовано</div>
        </div>
      )}
      <ModalConfirmation isOpen={open} onClose={handleClose} onConfirm={onConfirmDelete} id={id} />
      <div className="streaming-records-item__information">
        <div className="streaming-records-item__user">
          <NavLink
            to={`/city/${city?.id}/doctors/${doctor.id}`}
            className="streaming-records-item__user-icon"
            style={{ backgroundImage: `url(${doctor.photo ?? defaultMedicSvg})` }}
          />
          <div className="streaming-records-item__user-about">
            <NavLink to={`/city/${city?.id}/doctors/${doctor.id}`} className="streaming-records-item__user-title">
              <div className="streaming-records-item__user-title">{doctor.full_name}</div>
            </NavLink>

            <div className="streaming-records-item__user-description">
              {speciality?.name}
            </div>
          </div>
        </div>
        <div className="streaming-records-item__address">
          <ul className="streaming-records-item__address-list">
            <li className="streaming-records-item__address-list-item">
              <div className="streaming-records-item__address-list-item-title">Адреса</div>
              <div className="streaming-records-item__address-list-item-description">
                {division.address ? division.address.display_text : ' - '}
              </div>
            </li>
            <li className="streaming-records-item__address-list-item">
              <div className="streaming-records-item__address-list-item-title">Кабінет</div>
              <div className="streaming-records-item__address-list-item-description">
                <strong>{cabinet_num || '-'}</strong>
              </div>
            </li>
            <li className="streaming-records-item__address-list-item">
              <div className="streaming-records-item__address-list-item-title">Заклад</div>
              <div className="streaming-records-item__address-list-item-description">
                <NavLink to={`/city/${city?.id}/hospitals/${institution.id}?division_id=${division.id}`}>
                  {division.full_name}
                </NavLink>
              </div>
            </li>
            {!!division.contacts?.length && division.contacts.find(({ type }) => type === 'phone') && (
              <li className="streaming-records-item__address-list-item">
                <div className="streaming-records-item__address-list-item-title">Телефон реєстратури</div>
                <div className="streaming-records-item__address-list-item-description">
                  {division.contacts.reduce(
                    (acc, contact) =>
                      contact.type === 'phone'
                        ? `${acc.length ? `${acc}, ${contact.value}` : `${contact.value}`}`
                        : acc,
                    '',
                  )}
                </div>
              </li>
            )}
            {!patient && (
              <li className="streaming-records-item__address-list-item">
                <div className="streaming-records-item__address-list-item-title">Пацієнт</div>
                <div className="streaming-records-item__address-list-item-description">
                  {props.data.json_data?.patient_last_name || '-'} {props.data.json_data?.patient_name || '-'}
                </div>
              </li>
            )}
          </ul>
        </div>
        {is_video_conference === 1 && (duration <= 10 && duration >= -15) && (
            <div className="text-center">
              <a className="streaming-records-item__period-action btn btn-primary" href={'https://'+(process.env.REACT_APP_ENV.toLowerCase() === 'production' ? 'ehealth' : 'preprod')+'.ciet-holding.com/video/?user_name=' + encodeURIComponent(patient.full_name) + '&meeting_id=' + uid_video_conference } target="_blank" rel="noopener noreferrer" style={{'color': '#fff'}}><img src={videoSvg} width={25} alt="video" style={{'margin-right': '10px'}}/> Долучитись до онлайн телемедичного прийому</a>
            </div>
        )}
        {is_video_conference === 1 && !isPast && duration > 10 && (
            <div className="text-center">
              <p>
                Посилання на застріч буде тут за 10 хв до її початку. 
              </p>
              <p>
                <strong>Початок зустрічі о {moment(start_at).format('HH:mm, DD.MM.YYYY')}.</strong>
              </p>
            </div>
        )}
      </div>

      <div className="streaming-records-item__period">
        <div className="streaming-records-item__period-date">
          {is_video_conference === 1 && (
              <p>Онлайн прийом</p>
          )}
          <strong>{time_from}</strong>
          {moment(work_date).format('DD.MM.YYYY')}
        </div>
        {!isPast && !deleted && (
          <Button
            className="streaming-records-item__period-action"
            onClick={handleOpen}
            disabled={!cancelable}
            title={cancelable_comment}
          >
            <i className="fas fa-ban" />
            Скасувати прийом
          </Button>
        )}
      </div>
    </div>
  );
}
